const Divider = {
  baseStyle: {
    borderWidth: "1px",
    borderStyle: "solid",
    borderRadius: "10",
    borderColor: "slate.100",
    _dark: {
      borderColor: "grayscale.500"
    }
  }
};

export { Divider };
